// Public support email shown across the site and used by all contact forms.
// Override at build time via VITE_SUPPORT_EMAIL.
export const SUPPORT_EMAIL =
  (import.meta.env.VITE_SUPPORT_EMAIL as string | undefined) ?? "support@vecurate.net";

export type SupportRequestType =
  | "contact"
  | "review_report"
  | "account_deletion"
  | "dmca"
  | "privacy"
  | "support";

export const REQUEST_TYPE_LABELS: Record<SupportRequestType, string> = {
  contact: "Contact",
  review_report: "Review Report",
  account_deletion: "Account Deletion Request",
  dmca: "DMCA / Copyright Notice",
  privacy: "Privacy Request",
  support: "General Support",
};
